module.exports = __webpack_public_path__ + "img/primeira-consulta-programada.a1d0b5a5.svg";